module.exports = __webpack_public_path__ + "img/logo.62bad862.png";